import React, { FC, useEffect } from 'react';
import { Modal } from 'Shared/components/Modal/Modal';
import { RateChangeModalData } from '../../useReportRunner';

import styles from './styles.module.css';
import { Button } from '@clearcover/atlas';
import { useFooter } from 'QuoteApp/utils/hooks';
import { reportEvent } from 'Shared/analytics';

type RateChangeModalProps = {
  open: boolean;
  onClose(): void;
  rateChangeModalData?: RateChangeModalData | null;
  reportName: string;
};

const RateChangeModal: FC<RateChangeModalProps> = ({
  open,
  onClose,
  rateChangeModalData,
  reportName,
}) => {
  const { previousStep } = useFooter(4);
  const reportId = reportName
    .replace(/\./g, '')
    .replace(/ /g, '-')
    .toLowerCase();

  useEffect(() => {
    if (open && rateChangeModalData) {
      reportEvent('aqui-report-modal-displayed', { reportName });
    }
  }, [open, reportName, rateChangeModalData]);

  if (!rateChangeModalData) {
    return null;
  }

  return (
    <Modal showModal={open}>
      <div
        id={`${reportId}-rate-change-modal`}
        className={styles.modalContainer}
        data-testid="rate-change-modal"
      >
        <h1 className={styles.header}>Price quote has changed</h1>
        <p className={styles.content}>
          Based off the last report you ran, there was a price change to the
          previous quote amount.
        </p>

        <div className={styles.priceContainer}>
          <div>
            <p className={styles.priceLabel}>Previous Price</p>
            <p className={styles.priceValue}>
              {rateChangeModalData?.initialInstallmentAmount} /{' '}
              {rateChangeModalData?.paymentFrequencyLabel}
            </p>
          </div>
          <div>
            <p className={styles.priceLabel}>New Price</p>
            <p className={styles.priceValue}>
              {rateChangeModalData?.newInstallmentAmount} /{' '}
              {rateChangeModalData?.paymentFrequencyLabel}
            </p>
          </div>
        </div>

        <p className={styles.content}>
          Please confirm new price with customer before proceeding.
        </p>
        <div className={styles.footer}>
          <Button
            id={`${reportId}-rate-change-return-to-summary`}
            variant="secondary"
            onClick={() => {
              reportEvent('aqui-report-modal-return-to-summary', {
                reportName,
              });
              previousStep.onClickSuccess();
            }}
            data-testid="return-to-summary"
          >
            Return to summary
          </Button>
          <Button
            id={`${reportId}-rate-change-continue-to-next-report`}
            variant="primary"
            onClick={() => {
              reportEvent('aqui-report-modal-next-report', { reportName });
              onClose();
            }}
            data-testid="continue-to-next-report"
          >
            Continue to next report
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RateChangeModal;
